import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Row, Col, Spinner, FormGroup, Form, Input } from "reactstrap";
import Select from 'react-select';
import MaterialTable from 'material-table';
import moment from 'moment';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// api
import contrato_api from "../../../api/contrato_api.js";
import nfpscontrato_api from "../../../api/nfpscontrato_api.js";

// helpers
import { showMessage, showQuestion } from "../../../helpers/message.js";

export default function EntradaNFPS() {
    const [showLoading, setshowLoading] = useState(false);

    const [options_contratos, set_options_contratos] = useState([]);
    const [contrato, set_contrato] = useState(null);
    const [competencia, set_competencia] = useState("");
    const [nfps, set_nfps] = useState("");
    const [observacao, set_observacao] = useState("");

    const [historico, set_historico] = useState([]);
    const [editando, set_editando] = useState(false);

    const loadContratosVigentes = () => {
        contrato_api.getAllVigentes().then(result => {
            if (result.status === 200) {
                set_options_contratos(result.data);
            }
        });
    }

    const loadHistorico = (contrato_Id) => {
        if (!contrato_Id) {
            set_historico([]);
            return;
        }
        nfpscontrato_api.getHistorico(contrato_Id).then(result => {
            if (result.status === 200) {
                set_historico(result.data);
            } else {
                showMessage("Aviso", result.message, 'error', null);
            }
        });
    }

    const handleChangeContrato = (value) => {
        set_contrato(value);
        set_nfps("");
        set_observacao("");
        set_editando(false);
        loadHistorico(value ? value.contrato_Id : null);
    }

    const editarLancamento = (rowData) => {
        set_competencia(moment(rowData.competencia).format("YYYY-MM"));
        set_nfps(String(rowData.nfps));
        set_observacao(rowData.observacao || "");
        set_editando(true);

        if (rowData.jaCalculado) {
            showMessage("Atenção", "Essa competência já possui cálculo de FDE gerado. Ao salvar, será necessário recalcular manualmente para refletir a alteração.", 'warning', null);
        }
    }

    useEffect(() => {
        loadContratosVigentes();
    }, []);

    const salvar = () => {
        if (!contrato) {
            showMessage("Aviso", "Selecione o contrato.", 'warning', null);
            return;
        }
        if (!competencia) {
            showMessage("Aviso", "Selecione a competência.", 'warning', null);
            return;
        }
        if (nfps === "" || Number(nfps) < 0 || Number(nfps) > 10) {
            showMessage("Aviso", "O valor NFPS deve estar entre 0 e 10.", 'warning', null);
            return;
        }

        const competenciaFormatada = competencia + "-01";
        const jaLancado = historico.some(h => moment(h.competencia).format("YYYY-MM") === competencia);

        const executarSalvar = () => {
            setshowLoading(true);
            nfpscontrato_api.postNFPS({
                contrato_Id: contrato.contrato_Id,
                competencia: competenciaFormatada,
                nfps: Number(nfps),
                observacao: observacao
            }).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                } else {
                    showMessage("Sucesso", "NFPS lançado com sucesso!", 'success', null);
                    set_nfps("");
                    set_observacao("");
                    set_editando(false);
                    loadHistorico(contrato.contrato_Id);
                }
            });
        }

        if (jaLancado && !editando) {
            showQuestion("Atenção", "Já existe um lançamento de NFPS para essa competência. Deseja substituir?", "warning", function (confirmado) {
                if (confirmado) executarSalvar();
            });
        } else {
            executarSalvar();
        }
    }

    return (
        <div className="content">
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <h4 className="titleCard">Entrada NFPS</h4>
                        </CardHeader>
                        <CardBody>
                            <Form>
                                <Row className="align-items-end">
                                    <Col lg="6" md="12" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Contrato</label>
                                            <Select
                                                options={options_contratos}
                                                getOptionLabel={o => o.identificacao}
                                                getOptionValue={o => o.contrato_Id}
                                                value={contrato}
                                                onChange={handleChangeContrato}
                                                classNamePrefix="select"
                                                placeholder="[ Selecione o contrato ]"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3" md="6" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Competência</label>
                                            <Input className="form-control"
                                                type="month"
                                                value={competencia}
                                                onChange={(e) => set_competencia(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3" md="6" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Valor NFPS (0-10)</label>
                                            <Input className="form-control"
                                                type="number"
                                                min="0"
                                                max="10"
                                                step="0.01"
                                                disabled={!contrato}
                                                value={nfps}
                                                onChange={(e) => set_nfps(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="12" md="12" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Observação</label>
                                            <Input className="form-control"
                                                type="textarea"
                                                disabled={!contrato}
                                                value={observacao}
                                                onChange={(e) => set_observacao(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="button" onClick={salvar} disabled={!contrato}>
                                            <i className="fas fa-save"></i>  {editando ? "Salvar edição" : "Salvar"}
                                        </Button>
                                        {editando &&
                                            <Button color="secondary" type="button" onClick={() => { set_nfps(""); set_observacao(""); set_competencia(""); set_editando(false); }}>
                                                Cancelar edição
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Form>

                            {contrato &&
                                <>
                                    <hr />
                                    <h5>Histórico de lançamentos</h5>
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'Competência', field: 'competencia', render: rowData => <span>{moment(rowData.competencia).format("MM/YYYY")}</span> },
                                            { title: 'NFPS', field: 'nfps' },
                                            { title: 'Observação', field: 'observacao' }
                                        ]}
                                        data={historico}
                                        isLoading={false}
                                        actions={[
                                            {
                                                icon: 'edit',
                                                tooltip: 'Editar lançamento',
                                                onClick: (event, rowData) => editarLancamento(rowData)
                                            }
                                        ]}
                                        options={{
                                            ...table_style,
                                            filtering: false,
                                            paging: false,
                                            exportButton: false,
                                            actionsColumnIndex: -1
                                        }}
                                        localization={table_translate}
                                    />
                                </>
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
